import { type LogEntry } from '@/lib/types';
import LogEntryUploadedImagesContextProvider from './LogEntryUploadedImagesContextProvider';
import LogEntryExternalFilesContextProvider from './LogEntryExternalFilesContextProvider';
import FileAttachments from '@/components/FileAttachments';

type LogEntryFilesProps = {
  logEntry: LogEntry;
};

const LogEntryFiles = ({ logEntry }: LogEntryFilesProps) => (
  <LogEntryUploadedImagesContextProvider logEntry={logEntry}>
    <LogEntryExternalFilesContextProvider logEntry={logEntry}>
      <FileAttachments />
    </LogEntryExternalFilesContextProvider>
  </LogEntryUploadedImagesContextProvider>
);

export default LogEntryFiles;
